<template>
  <div class="row wrapper border-bottom white-bg page-heading">
    <div class="col-lg-10">
      <h2>Grupy opcji</h2>
      <ol class="breadcrumb">
        <li>
          <router-link to="/">Home</router-link>
        </li>
        <li class="active">
          <router-link to="/product-option-group/list">Grupy opcji</router-link>
        </li>
        <li class="active">
          <strong>Nowa</strong>
        </li>
      </ol>
    </div>
  </div>

  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="row">
      <div class="col-lg-12">
        <div class="ibox float-e-margins">
          <div class="ibox-title">
            <h5>Dane grupy</h5>
          </div>

          <div class="form-horizontal">
            <div class="ibox-content">
              <div
                v-for="field in nameFields"
                :key="field.key"
                class="form-group"
              >
                <label class="control-label col-sm-2">{{ field.label }}</label>
                <div class="col-sm-10">
                  <input
                    v-model="groupObj[field.key]"
                    :name="field.key"
                    type="text"
                    class="form-control inputClass"
                    :placeholder="field.label"
                    required="required"
                  />
                  <div
                    v-if="errorsAdminData?.data?.[field.key]"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data[field.key][0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Opis</label>
                <div class="col-sm-10 QuillEditor-box">
                  <QuillEditor
                    theme="snow"
                    contentType="html"
                    v-model:content="groupObj.description"
                  />
                  <div
                    v-if="errorsAdminData?.data?.description"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.description[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <label class="control-label col-sm-2">Wybór</label>
                <div class="col-sm-10">
                  <Multiselect
                    v-model="groupObj.group_choice"
                    mode="single"
                    placeholder="Wybór"
                    track-by="name"
                    label="name"
                    :close-on-select="true"
                    :searchable="true"
                    :options="groupChoices"
                  >
                  </Multiselect>
                  <div
                    v-if="errorsAdminData?.data?.group_choice"
                    class="has-error"
                  >
                    <span class="help-block">
                      {{ errorsAdminData.data.group_choice[0] }}
                    </span>
                  </div>
                </div>
              </div>

              <div
                v-for="field in checkboxFields"
                :key="field.key"
                class="form-group"
              >
                <div class="col-sm-offset-2 col-sm-10">
                  <div class="checkbox checkbox-primary">
                    <label>
                      <input
                        v-model="groupObj[field.key]"
                        :name="field.key"
                        type="checkbox"
                      />
                      <span>{{ field.label }}</span>
                    </label>
                  </div>
                </div>
              </div>

              <div class="form-group">
                <div class="col-sm-4 col-sm-offset-2">
                  <router-link
                    class="btn btn-white"
                    to="/product-option-group/list"
                  >
                    Anuluj
                  </router-link>
                  <button
                    v-if="canAddGroup"
                    @click="create"
                    class="btn btn-primary"
                  >
                    Dodaj
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";
import router from "../../router/router";
import { hasPermission } from "../../permissions";
import { productOptionGroupPermissionsConst } from "../../constants/productConstants";

// Mirrors ProductOptionGroupCreateController from the old admin panel.
export default {
  name: "ProductOptionGroupCreate",
  components: {
    Multiselect,
  },

  setup() {
    const store = useStore();
    const canAddGroup = computed(() =>
      hasPermission(productOptionGroupPermissionsConst.add)
    );
    const createGroupData = computed(
      () => store.getters.getCreatepOptionsGroupData
    );
    const groupChoicesData = computed(() => store.getters.getPOGChoicesData);

    const nameFields = [
      { key: "name_pl", label: "Nazwa pl" },
      { key: "name_en", label: "Nazwa en" },
      { key: "name_de", label: "Nazwa de" },
      { key: "name_cpde", label: "Nazwa de_de" },
      { key: "name_cpen", label: "Nazwa de_en" },
    ];
    const checkboxFields = [
      { key: "determines_paper_type", label: "Określa rodzaj papieru" },
      { key: "select_from_list", label: "Wybór z listy" },
      {
        key: "hide_in_order",
        label: "Ukryj na karcie zamówienia i karcie montażu",
      },
    ];

    const groupObj = ref({
      name_pl: "",
      name_en: "",
      name_de: "",
      name_cpde: "",
      name_cpen: "",
      description: "",
      group_choice: null,
      determines_paper_type: false,
      select_from_list: false,
      hide_in_order: false,
    });
    const groupChoices = ref([]);
    const errorsAdminData = ref();

    const create = () => {
      if (!canAddGroup.value) {
        return;
      }
      errorsAdminData.value = undefined;
      store.dispatch("createpOptionsGroup", groupObj.value);
    };

    store.dispatch("getPOGChoices");

    watch(
      () => groupChoicesData.value,
      function (newValue) {
        groupChoices.value = (newValue?.data || []).map((element) => ({
          name: element[1],
          value: element[0],
        }));
      }
    );

    watch(
      () => createGroupData.value,
      function (newValue) {
        if (newValue?.status === 201) {
          router
            .push({
              name: "ProductOptionList",
              path: "/product-option-group/list",
            })
            .then(() => {
              store.dispatch("showToaster", {
                type: "success",
                content: "Dodano nową grupę!",
              });
            });
        } else if (newValue?.status) {
          const msg = [];
          for (const [key, value] of Object.entries(newValue.data || {})) {
            msg.push(key + ": " + value);
          }

          store.dispatch("showToaster", {
            type: "error",
            content: msg[0],
          });
          errorsAdminData.value = newValue;
        }
      }
    );

    return {
      canAddGroup,
      nameFields,
      checkboxFields,
      groupObj,
      groupChoices,
      errorsAdminData,
      create,
    };
  },
};
</script>
